import * as React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "../../config";
import clsx from 'clsx';
import Grid from "@material-ui/core/Grid/Grid";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import { BrowserRouter as Router, Link as RouterLink } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
    index: {
        paddingTop: '0!important',
    },
    indexFirst: {
        paddingLeft: '0!important',
    },
    indexMid: {
        paddingLeft: '6px!important',
        ['@media (max-width:700px)']: {
            paddingRight: '0 !important',
        },
    },
    indexLast: {
        paddingRight: '0!important',
    },
    item: {
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#ccc',
        //opacity: .1,
        //transition: 'visibility 0s, opacity 0.5s linear',
        '&::after': {
            boxSizing: 'inherit',
            content: '""',
            position: 'absolute',
            borderBottom: '2px solid transparent',
            width: '0',
            height: 2,
            bottom: 0,
            left: 0,
        },
        '&:hover': {
            '&::after': {
                width: '100%',
                height: 2,
                borderBottomColor: '#3849a4',
                transition: 'width 0.15s ease-out, height 0.15s ease-out 0.15s'
            },
        }
    },
    h3: {
        position: 'absolute',
        top: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        wcolor: '#fff',
        color: '#000',
        fontWeight: 'normal',
        margin: '7px 0 0 10px',
        maxWidth: 300,
        whiteSpace: 'nowrap',
        overflowX: 'hidden'
    },
    h3Big: {
        fontSize: '1.4rem',
        letterSpacing: '.09rem',
        maxWidth: 300,
        whiteSpace: 'nowrap',
        overflowX: 'hidden'
    },
    h3Small: {
        fontSize: '1.2rem',
        letterSpacing: '.08rem',
    },
    header: {
        position: 'absolute',
        top: 0,
        wbackgroundColor: '#3849a4',
        backgroundColor: '#fff',
        borderTop: '1px dashed #ccc',
        borderLeft: '1px dashed #ccc',
        borderRight: '1px dashed #ccc',
        width: 'calc(100% - 2px)',

    },
    headerBig: {
        height: 40,
    },
    headerSmall: {
        height: 35,
    },
    price: {
        position: 'absolute',
        top: 0,
        right: 1,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        wcolor: '#fff',
        color: '#000',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        paddingLeft: 10,
        paddingRight: 9,
        paddingBottom: 5,
    },
    priceBig: {
        margin: '10px 0 0 0',
    },
    priceSmall: {
        margin: '7px 0 0 0',
    },
    options: {
        position: 'absolute',
        bottom: 0,
        height: 32,
        width: '100%',
        backgroundColor: '#fafafa',
        opacity: .95,
    },
    option: {
        position: 'absolute',
        bottom: 0,
        height: 32,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '.9rem'
    },
    optionValue: {
        position: 'absolute',
        height: 23,
        paddingTop: 9,
        paddingLeft: 10,
        whiteSpace: 'nowrap',
        overflow: 'hidden',

    },
    year: {
        left: 0,
    },
    location: {
        left: 80,
    },
    mileage: {
        left: 215,
    },
    mileageSmall: {
        left: 120,
    },
    button: {
        position: 'absolute',
        bottom: 7,
        right: 7
    },
    link: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: '#415ae3'
    },
    linkNoImage: {
        color: '#fff',
        textDecoration: 'none'
    },
    comingSoon: {
        position: 'absolute',
        width: 'auto',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: '#fff',
        top: 'calc(50% - 18px)',
        left: 'calc(50% - 47px)',
        textAlign: 'center',
        cursor: 'pointer'
    },
    analytics: {
        position: 'absolute',
        width: 'calc(100% - 2px)',
        bottom: 0,
        backgroundColor: '#fff',
        height: 32,
        borderBottom: '1px solid #ddd',
        borderLeft: '1px solid #ddd',
        borderRight: '1px solid #ddd'
    },
    analyticsItem: {
        borderRadius: 2,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: '#000',
        marginLeft: 10,
        marginRight: 5,
        marginTop: 8,
        fontSize: '.9rem',
        display: 'inline-block'
    }
}));

export function ListItem(props) {

    const classes = useStyles();

    const item = props.item;
    const isMobile = props.isMobile;
    const titleLength = 135;

    const city = item.city ? item.city.split(' ').join('-') : '';
    let title = item.title ? item.title.split(' ').join('-').split('/').join('-') : '';
    title = title.split('"').join('in');
    const alt = item.year + ' ' + title + ' in ' + city + ',' + item.state;
    const url = item.requestCode ? `/request/${item.requestCode}`
        : `/for-sale/${title}/location/${city}-${item.state}/${item.sn}`;

    const headerTitle = item.title;// ? item.title.split(' ').slice(0, 3).join(' ') : '';

    let className = 'Mid';

    switch (props.size) {
        case 'xxxl':
            className = (props.index+1) % 3 === 0 ? 'Last' : props.index % 3 === 0 ? 'First' : 'Mid';
            break;
        case 'xxl':

            break;
        default:
            break;

    }

    let isBig = props.cellW >= 350;

    return <Router key={item.sn}><Grid item sm={props.span} className={clsx(classes.index, classes['index'+className])}>
        <div className={classes.item} style={{
            width: props.cellW+'px',
            height: props.cellH+'px',
            //opacity: item.image ? .1 : 1
        }}>
            {item.image ?
                <RouterLink className={classes.link} to={url} onClick={() => {
                    props.handleClick(item, props.returnRoute)
                }}><img className={classes.image} width={props.cellW}
                    src={serverRootUrl + "/" + item.image} alt={alt} title={alt}/></RouterLink> :
                <div className={classes.comingSoon} onClick={() => {
                    props.handleClick(item, props.returnRoute)
                }}>
                    <RouterLink className={classes.linkNoImage} to={url} onClick={() => {
                        props.handleClick(item, props.returnRoute)
                    }}><PhotoCameraIcon className={classes.cameraIcon}/><br/>Coming soon</RouterLink></div>}
            <div className={clsx(classes.header, isBig ? classes.headerBig : classes.headerSmall)}>&#160;</div>
            <h3 className={clsx(classes.h3, isBig ? classes.h3Big : classes.h3Small)}>{headerTitle}</h3>

            <div className={clsx(classes.price, isBig ? classes.priceBig : classes.priceSmall)}>{item.sold ? 'Sold' : (item.price>0 ? <>${new Intl.NumberFormat().format((item.price) / 100)}</> : 'Get Price')}</div>
            <div className={classes.options}></div>
            <div className={clsx(classes.option, classes.year)}>
                <div className={classes.optionValue}>
                    <b>Year</b>: {item.year}
                </div>
            </div>
            { isBig ?
            <div className={clsx(classes.option, classes.location)}>
                <div className={classes.optionValue}>
                    <b>{item.city}</b>, {item.state}
                </div>
            </div> : null}
            <div className={clsx(classes.option, isBig ? classes.mileage : classes.mileageSmall)}>
                <div className={classes.optionValue}>
                    <b>{item.mileage},000</b> MI
                </div>
            </div>
            <div className={classes.button}>
                <div className={classes.buttonCont}>
                    <RouterLink className={classes.link} to={url} onClick={() => {
                        props.handleClick(item, props.returnRoute)
                    }}>Details</RouterLink>
                </div>
            </div>
            {item.analytics && localStorage.getItem('showHits') === '1' ?
                <div className={classes.analytics}>
                    <div className={clsx(classes.analyticsItem, classes.dailyHits)}><b>Today</b>: {new Intl.NumberFormat().format(item.analytics.dailyHits)}</div>
                    <div className={clsx(classes.analyticsItem, classes.yesterdayHits)}><b>Yesterday</b>: {new Intl.NumberFormat().format(item.analytics.yesterdayHits)}</div>
                    <div className={clsx(classes.analyticsItem, classes.hits)}><b>Total</b>: {new Intl.NumberFormat().format(item.analytics.hits)}</div>
                </div> : null}

        </div>
    </Grid></Router>;
}